export const URLs = {
    homePage: "https://www.christinamaryhendrietrust.co.uk/",
    TCs: "https://www.christinamaryhendrietrust.co.uk/terms-and-conditions",
    privacy: "https://www.christinamaryhendrietrust.co.uk/privacy-policy",
    cookies: "https://www.christinamaryhendrietrust.co.uk/privacy-policy",
}

export const APP_ROUTES = {
    ROOT: {
        ROOT: "/",
        DASHBOARD: "/dashboard",
        ACCOUNT: "/account",
        APPLICATION: "/application/:id",
        TRANSFER_OWNERSHIP: "/account/transfer-ownership",
    },
    AUTH: {
        INDEX: "/auth",
        LOGIN: "/auth/login",
        REGISTER: "/auth/register",
        LOGOUT: "/auth/logout",
        FORGOT_PASSWORD: "/auth/forgot-password",
        RESET_PASSWORD: "/auth/reset-password",
    },
}
